import React from 'react';
import { Typography } from 'antd';
import { motion } from 'framer-motion';
import './style.scss';

const { Title, Text } = Typography;

export interface PageHeaderProps {
  title: React.ReactNode;
  subtitle?: React.ReactNode;
  /** Right-aligned actions (buttons, pickers, etc.). */
  actions?: React.ReactNode;
  /** Optional leading icon/illustration. */
  icon?: React.ReactNode;
  className?: string;
}

/**
 * Consistent page header used across pages. Presentation only.
 */
const PageHeader: React.FC<PageHeaderProps> = ({ title, subtitle, actions, icon, className }) => {
  return (
    <motion.div
      className={`ui-page-header${className ? ` ${className}` : ''}`}
      initial={{ opacity: 0, y: -10 }}
      animate={{ opacity: 1, y: 0 }}
      transition={{ duration: 0.3, ease: [0.22, 1, 0.36, 1] }}
    >
      <div className="ui-page-header__left">
        {icon ? <div className="ui-page-header__icon">{icon}</div> : null}
        <div className="ui-page-header__titles">
          <Title level={3} className="ui-page-header__title">
            {title}
          </Title>
          {subtitle ? <Text className="ui-page-header__subtitle">{subtitle}</Text> : null}
        </div>
      </div>
      {actions ? <div className="ui-page-header__actions">{actions}</div> : null}
    </motion.div>
  );
};

export default PageHeader;
